
import React, { useState } from "react";
import { ReactComponent as ArrowRight } from './reshot-icon-arrow-left-4NA6KJF8CU.svg';
import { ReactComponent as ArrowLeft } from './reshot-icon-arrow-right-ZP2WDL9B8N.svg';
import SI from "./images/SI Auto Tracker.png"

import { ReactComponent as Icon1 } from './svg/python-svgrepo-com.svg';
import { ReactComponent as Icon2 } from './svg/react-svgrepo-com.svg';
import './ProjectPage.css';


const Carousel = ({ data }) => {
  const [slide, setSlide] = useState(0);

  const nextSlide = () => {
    if (slide === data.length - 1) 
    {
      setSlide(0);
    } else 

    {
      setSlide(slide + 1);
    }
  };
  
  const prevSlide = () => {
    if (slide === 0) {
      setSlide(data.length - 1);
    } else 
    
    {
      setSlide(slide - 1);
    }
  };

  return (
    <div className="carousel">
      <ArrowLeft onClick={prevSlide} className="arrow arrow-left" />
      {data.map((item, idx) => {
        return (
          <img
            src={item.src}
            alt={item.alt}
            key={idx}
            className={slide === idx ? "slide" : "slide slide-hidden"}
          />
        );
      })}
      <ArrowRight
        onClick={nextSlide}
        className="arrow arrow-right"
      />
      <span className="indicators">
        {data.map((_, idx) => {
          return (
            <button
              key={idx}
              className={
                slide === idx ? "indicator" : "indicator indicator-inactive"
              }
              onClick={() => setSlide(idx)}
            ></button>
          );
        })}
      </span>
    </div>
  );
};

export default function ProjectPage() {


  const data3 = [
    {src: SI, alt: "Student Tracking"}
  ];

  return (

    <div className="App">

        <div className = "home-page-container">
          
       

          <div className = "green-line-bottom"> 

            <div className = "link-container">
                  
                  <heading className = "header-avry-5"> Projects </heading>

              </div> 

         
          </div>


   <div className = "container-carousel">
             <header style = {{ color: "#1bbb75", textDecoration: "None", textDecorationColor: "green" }}className ="header-avry3">Senior Project: College Navigator</header>
   </div>
              {/* Carousel Component */}
             
              <div className = "video-wrap">

              <div className = "video-container">

                       <iframe
              title="Youtube player"
              sandbox="allow-same-origin allow-forms allow-popups allow-scripts allow-presentation"
              src={`https://youtube.com/embed/${"zVwSBH_KcZk"}?autoplay=0`}
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen

            >

            </iframe>
              </div>
                    

               <div className = "container-carousel">
                {/* <a className = "project-github" href = "https://avryjacksoncom.github.io">Project Notes</a> */}
   
         
               
                <header className="header-avry3">Tech Stack: </header>

                <div className="icon-group">
                  <div className="icon-item">
                    <Icon1 className="icon-img" title="Python" />
                    <p className="icon-label">Python</p>
                  </div>
                  <div className="icon-item">
                    <Icon2 className="icon-img" title="React" />
                    <p className="icon-label">React</p>
                  </div>
       
                </div>
                   <p  style = {{fontSize:18.1}} className = "paragraph-about-me">
                      I know from experience I always forget
                 what resources we have, and where to go. Especially if i have like exams that week so 
                 I'm developing a local mapping app for our college, similar to Google Maps. The app 
                 will help students easily navigate to their classes, find important locations,
                 and explore the campus with a user-friendly interface. 
                  The goal is to provide a simple and efficient
                  tool that enhances the campus experience by making it easier for students to 
                  get around and locate key spots on campus. I'm making this for Senior Design and will
                  continue to improve it to develop a local map app for any campus, convention, and or
                  place that needs extra navigation!
                </p>
    
              {/* end of carousel compenent container */}
              </div>
              
            
               </div>
             
              <div className = "green-line-bottom"> </div>

              <div className = "container-carousel">
              {/* <a className = "project-github" href = "https://avryjacksoncom.github.io">Project Notes</a> */}
                <header style = {{ color: "#1bbb75", textDecoration: "None", textDecorationColor: "green" }}className = "header-avry3">Tutor Tracking</header>
                   <Carousel data={data3} />
                 <header className="header-avry3">Details: Tutor</header>
                <div className="icon-group">
                  <div className="icon-item">
                    <Icon1 className="icon-img" title="Python" />
                    <p className="icon-label">Python</p>
                  </div>
                  <div className="icon-item">
                    <Icon2 className="icon-img" title="React" />
                    <p className="icon-label">React</p>
                  </div>
                </div>
                <p  style = {{fontSize:18.1}} className = "paragraph-about-me">
                  I worked as a tutor supporting professors and students in computer science 
                  labs, helping with programming, algorithms, and software engineering. To make 
                  tracking student support easier, I built a Python and React-based program that
                  records student tracking in tutoring sessions and stores the data in Excel.
                  The tool simplified attendance tracking and weekly reports, saving time for me.
                  I gave some of my comp sci tutoring collegaues the repo.  



                </p>

                    {/* <Carousel data={data2} /> */}

              {/* end of carousel compenent container */}
              </div>

           {/* Carousel Component */}
                     <div className = "green-line-bottom"> </div>
                <div className = "container-carousel">
                {/* <a className = "project-github" href = "https://avryjacksoncom.github.io">Project Notes</a> */}
                <a style={{ color: "#1bbb75", textDecoration: "None", textDecorationColor: "green" }}href = "https://github.com/avryjacksoncom/deployReactHostinger"><header style = {{ color: "#1bbb75", textDecoration: "underline", textDecorationColor: "green" }}className ="header-avry3">Automation Web Script</header></a>
              
      
                <div className="icon-group">
                  <div className="icon-item">
                    <Icon1 className="icon-img" title="Python" />
                    <p className="icon-label">Python</p>
                  </div>
       
                </div>
                   <p  style = {{fontSize:18.1}} className = "paragraph-about-me">
                I created a Python automation script that updates and deploys content across multiple websites, reducing manual
                update time by 80% and ensure consistent and efficient deployment processes.  
                </p>
    
              {/* end of carousel compenent container */}
              </div>
              
              {/* <div className = "green-line-bottom"> </div> */}


              

        {/* Home-page-container div */}
        </div>

    {/* End of entire div */}
    </div>
  );
}


//  {/* Carousel Component */}
                
//                 <div className = "container-carousel">
//                 {/* <a className = "project-github" href = "https://avryjacksoncom.github.io">Project Notes</a> */}
//                 <a style={{ color: "#1bbb75", textDecoration: "None", textDecorationColor: "green" }}href = "https://github.com/avryjacksoncom/jewelry-script-singular-files"><header style = {{ color: "#1bbb75", textDecoration: "underline", textDecorationColor: "green" }}className ="header-avry3">Jewelry Duplicate Files Script</header></a>
              
      
//                 <div className="icon-group">
//                   <div className="icon-item">
//                     <Icon1 className="icon-img" title="Python" />
//                     <p className="icon-label">Python</p>
//                   </div>
       
//                 </div>
//                    <p  style = {{fontSize:18.1}} className = "paragraph-about-me">
//                At Jewelry Exchange, I automated duplicate detection in a 12,000+ image directory using Python, successfully
//                 removing more than 200 redundant files
//                 </p>
    
//               {/* end of carousel compenent container */}
//               </div>